module.exports = __webpack_public_path__ + "static/gnoll_band-bfbecac3a814dda34550a0563ca3d56e.jpg";